/*
 * Planner Messages
 *
 * This contains all the text for the Planner component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.components.Planner.General.title',
    defaultMessage: 'Title',
  },
  description: {
    id: 'app.components.Planner.General.description',
    defaultMessage: 'Description',
  },
  duration: {
    id: 'app.components.Planner.General.duration',
    defaultMessage: 'Time Slot',
  },
  inBetween: {
    id: 'app.components.Planner.General.inBetween',
    defaultMessage: 'Pause between meetings',
  },
  warnDuration: {
    id: 'app.components.Planner.General.warnDuration',
    defaultMessage: 'Only applies to new time blocks and slots',
  },
  warnLocation: {
    id: 'app.components.Planner.General.warnLocation',
    defaultMessage: 'Meetings already planned will not be updated',
  },
  group: {
    id: 'app.components.Planner.General.group',
    defaultMessage: 'Group',
  },
  next: {
    id: 'app.common.next',
    defaultMessage: 'Next',
  },
  intro: {
    id: 'app.components.Planner.General.intro',
    defaultMessage: 'The title and description will be used in notifications to parent about the meetings.',
  },
  meetingLocationType: {
    id: 'app.components.Planner.meetingLocationType',
    defaultMessage: 'Location',
  },
  locationTypeHelp: {
    id: 'app.components.Planner.locationTypeHelp',
    defaultMessage: 'You can set a different location for individual students.',
  },
  videoExplain1: {
    id: 'app.components.Planner.videoExplain1',
    defaultMessage: 'Video conferences take place using <b>Microsoft Teams</b> or <b>Google Meet</b>.',
  },
  videoExplain2: {
    id: 'app.components.Planner.videoExplain2',
    defaultMessage: 'In step 4 you can easily add links to the video conference.',
  },
});
